import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';
import { authApi } from '../api/auth.api';
import { useCallback } from 'react';
import type { LoginRequest } from '../api/auth.api';

/**
 * Custom hook for authentication
 */
export function useAuth() {
  const { token, user, isAuthenticated, setAuth, clearAuth, setUser } = useAuthStore();
  const navigate = useNavigate();

  const login = useCallback(
    async (credentials: LoginRequest) => {
      const response = await authApi.login(credentials);

      if (response.status === 'success' && response.data) {
        setAuth(response.data.accessToken, response.data.admin);
        // Store token in localStorage for axios interceptor
        localStorage.setItem('admin_token', response.data.accessToken);
        localStorage.setItem('admin_user', JSON.stringify(response.data.admin));
        return { success: true };
      }

      return { success: false, message: response.message || 'Login failed' };
    },
    [setAuth]
  );

  const logout = useCallback(() => {
    authApi.logout();
    clearAuth();
  }, [clearAuth]);

  const refreshUser = useCallback(async () => {
    if (!token) return;

    try {
      const response = await authApi.getCurrentAdmin();
      if (response.status === 'success' && response.data) {
        setUser(response.data);
      }
    } catch (error) {
      console.error('Failed to refresh user:', error);
      logout();
    }
  }, [token, setUser, logout]);

  return {
    token,
    user,
    isAuthenticated,
    login,
    logout,
    refreshUser,
  };
}
